module.exports = __webpack_public_path__ + "fonts/fa-v2-regular-400.6c2e7024.woff";